/** 已有系统配置查询接口；模块名称与数据库菜单目录一致，不回退模拟目录。 */
import { apiGet } from './http-client'
import type { SysConfigModule, SysConfigItem } from '../mock/sysconfig'
export const sysConfigRepo = {
  modules: () => apiGet<SysConfigModule[]>('/api/sys-config/modules'),
  byId: (id: string) => apiGet<SysConfigItem | undefined>('/api/sys-config/by-id', { id }),
  byMenu: (menuId: string) => apiGet<SysConfigItem[]>('/api/sys-config/by-menu', { menuId }),
  search: (kw: string) => apiGet<SysConfigItem[]>('/api/sys-config/search', { kw })
}
